import { fetchConfig, isJson, handlePurchaseLimitErrors } from '../common'
import { UmgGwp } from './umg-gwp'

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    connectedCallback () {
      this.form = this.querySelector('form')
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-items')
      this.variantId = this.getAttribute('data-variant')
      this.sectionId = this.getAttribute('data-section')
      this.purchase_limit_error = this.querySelector('div.purchase-limit-error') || document.querySelector('div.purchase-limit-error[data-variant-id="' + this.variantId + '"][data-section="' + this.sectionId + '"]')
      this.id = this.getAttribute('data-section')
      this.quantitySpinner = this.form.querySelector('quantity-spinner') || document.querySelector('quantity-spinner[data-variant-id="' + this.variantId + '"][data-section="' + this.sectionId + '"]')
      this.quantitySelector = this.form.querySelector('quantity-selector') || document.querySelector('quantity-selector[data-variant-id="' + this.variantId + '"][data-section="' + this.sectionId + '"]')
      if (this.quantitySpinner) {
        this.quantity_input = this.form.querySelector('.js-quantity-spinner-input')
      }
      this.designNumber = this.querySelector('#design_number')
    }

    async onSubmitHandler (evt) {
      evt.preventDefault()
      const flexibleBundlesWrapper = document.querySelector('umg-flexible-bundle')
      if (flexibleBundlesWrapper && flexibleBundlesWrapper.dataset.canAddToCart === 'false') {
        return
      }
      const flexibleBundlePropertiesElement = this.querySelector('umg-flexible-bundle [name="properties[_bundles_properties]"]')
      if (flexibleBundlePropertiesElement) {
        const flexBundleUUID = crypto.randomUUID()
        const flexBundleGtin = await this.getFlexBundleGtin(flexibleBundlesWrapper)
        const flexibleBundleProperties = JSON.parse(flexibleBundlePropertiesElement.value)
        let newProperties
        if (flexBundleGtin) {
          newProperties = flexibleBundleProperties.map(component => ({ ...component, attributes: { ...component.attributes, _flex_bundle_uuid: flexBundleUUID, _flex_bundle_gtin: flexBundleGtin } }))
        } else {
          newProperties = flexibleBundleProperties.map(component => ({ ...component, attributes: { ...component.attributes, _flex_bundle_uuid: flexBundleUUID } }))
        }
        flexibleBundlePropertiesElement.value = JSON.stringify(newProperties)
      }
      // This is in place to check and remove a pause cart item with the same product id and frame number, so another one can be added making it look like it was swapped and so we don't hit purchase limit.
      if (document.querySelector('#pause-video-json')) {
        let canAddToCart
        await import('./pause-product-form').then(async (module) => {
          canAddToCart = await module.checkFrameInCart(this.variantId, this)
        })
        if (canAddToCart === false) {
          return
        }
      }
      const submitButton = this.querySelector('[type="submit"]')
      const submitButtonLabel = submitButton.querySelector('.buybutton_label')
      const submitButtonLoadingSpinner = submitButton.querySelector('.icon--activity-spinning')

      if (submitButton.classList.contains('loading')) return
      submitButton.setAttribute('aria-disabled', true)
      submitButton.classList.add('loading')
      submitButtonLabel.classList.add('opacity-0')
      submitButtonLoadingSpinner.classList.remove('hidden')

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(this.form)

      let gwp_sections

      if (this.quantitySpinner != null && this.cartUI != null) {
        formData.append('sections', this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySpinner.getSectionsToRender().map((section) => section.id)))
        gwp_sections = this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySpinner.getSectionsToRender().map((section) => section.id))
      } else if (this.quantitySelector != null && this.cartUI != null) {
        formData.append('sections', this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySelector.getSectionsToRender().map((section) => section.id)))
        gwp_sections = this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySelector.getSectionsToRender().map((section) => section.id))
      } else {
        formData.append('sections', this.cartUI ? this.cartUI.getSectionsToRender().map((section) => section.id) : [])
        gwp_sections = this.cartUI ? this.cartUI.getSectionsToRender().map((section) => section.id) : []
      }
      formData.append('sections_url', window.location.pathname)
      const gwp_sections_url = window.location.pathname

      let quantity = 1

      if (this.quantitySpinner) {
        formData.append('quantity', this.quantitySpinner.input.value)
        quantity = parseInt(this.quantitySpinner.input.value)
      } else if (this.quantitySelector) {
        formData.append('quantity', this.quantitySelector.input.value)
        quantity = parseInt(this.quantitySelector.input.value)
      }

      this.has_cart_error = false

      config.body = formData
      // gfx save design

      if (this.designNumber) {
        try {
          const designNumber = this.designNumber.value
          await window.gfxInstance.actions.saveDesign({ designNumber: designNumber })
        } catch (error) {
          console.error('Error retrieving GFX designs')
        }
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (parsedState) => {
          // Purchase Limit Exceeded
          if (parsedState.status === 422) {
            // console.log('passing 422')
            // console.log(parsedState)
            // Show Purchase Limit Error
            const component_ref = formData.get('component_ref')
            this.has_cart_error = true
            const product_data = {
              id: formData.get('product_id'),
              component_ids: component_ref ? component_ref.split(',') : null
            }
            handlePurchaseLimitErrors(product_data, parsedState)

          // Add to Cart Successful
          } else {
            if (document.querySelector('#pause-video-json')) {
              // Pause reservation is made here if false it will remove item from cart and display error
              let addToCartSuccess
              await import('./pause-product-form').then(async (module) => {
                addToCartSuccess = await module.handlePauseReservation(parsedState, this.variantId, this)
              })
              if (addToCartSuccess === false) {
                return
              }
            }
            if (this.cartUI != null) {
              this.cartUI.renderContents(parsedState, true, true)
            }
            if (this.quantitySpinner != null) {
              this.quantitySpinner.renderContent(parsedState)
            } else if (this.quantitySelector != null) {
              this.quantitySelector.renderContent(parsedState)
            }
            if (!Shopify.designMode) {
              const gtm_item_name = this.querySelector('[name="gtm_item_name"]').getAttribute('value')
              const gtm_item_id = this.querySelector('[name="gtm_item_id"]').getAttribute('value')
              const gtm_item_collection = this.querySelector('[name="gtm_item_collection"]').getAttribute('value')
              const gtm_item_variant = this.querySelector('[name="gtm_item_variant"]').getAttribute('value')
              const gtm_item_upc = this.querySelector('[name="gtm_item_upc"]').getAttribute('value')
              const gtm_item_price = this.querySelector('[name="gtm_item_price"]').getAttribute('value')
              const gtm_item_brand = this.querySelector('[name="gtm_item_brand"]')?.getAttribute('value')
              const gtm_item_sku = this.querySelector('[name="gtm_item_sku"]')?.getAttribute('value')
              const gtm_item_group_id = this.querySelector('[name="gtm_item_group_id"]')?.getAttribute('value')
              const gtm_item_category = this.querySelector('[name="gtm_item_category"]')?.getAttribute('value')

              const customEvent = {
                currency: window.currentCurrency,
                items: [
                  {
                    item_name: gtm_item_name,
                    item_id: gtm_item_id,
                    item_category: gtm_item_collection,
                    item_variant: gtm_item_variant,
                    upc: gtm_item_upc,
                    price: parseFloat(gtm_item_price),
                    quantity: parseInt(quantity),
                  }
                ]
              }

              if (window.shop_iso_code === 'DE') {
                Object.assign(customEvent, {
                  items: [
                    {
                      ...customEvent.items[0],
                      category: gtm_item_category,
                      item_brand: gtm_item_brand,
                      item_sku: gtm_item_sku,
                      item_group_id: gtm_item_group_id,
                    }
                  ]
                })
              }

              Shopify.analytics.publish('cart_item_added', customEvent)
            }
            if (submitButton.closest('.atc__unfinished')) {
              submitButton.closest('.atc__unfinished').classList.remove('atc__unfinished')
            }

            if (window.umgGwp !== undefined) {
              // Don't call umg gift with purchase if no gift with purchase data exists
              UmgGwp(this.cartUI, gwp_sections, gwp_sections_url)
            }
          }
        })
        .catch((errors) => {
          console.error('error', errors)
          const error_message_html = `<ul>${errors.map(error => {
            return `<li>${error}</li>`
          }).join('')}</ul>`
          this.handleErrorMessage(error_message_html)
        })
        .finally(() => {
          // update pdp
          if (!this.has_cart_error) {
            const pdpInfoId = 'product__info'
            if (document.querySelector('#pause-video-json')) {
              document.querySelector('.product-form__submit .buybutton_label').innerHTML = window.variantStrings.extendCartTimer
            } else if (document.getElementsByClassName(pdpInfoId)[0] !== undefined) {
              const sectionId = document.getElementsByClassName(pdpInfoId)[0].getAttribute('id')
              this.renderProductInfo(sectionId)
            }
            submitButton.classList.remove('loading')
            submitButton.removeAttribute('disabled')
            submitButtonLabel.classList.remove('opacity-0')
            submitButtonLoadingSpinner.classList.add('hidden')
          }
        })
    }

    renderProductInfo (sectionId) {
      fetch(`${window.location.pathname}?section=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = `${sectionId}`
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const source = html.getElementById(id)
          const destination = this.closest(`#${id}`)
          if (source && destination) destination.innerHTML = source.innerHTML
        })
    }

    async getFlexBundleGtin (flexibleBundlesWrapper) {
      const gtinsStr = flexibleBundlesWrapper.dataset.gtins
      if (gtinsStr === 'null') return null
      const gtinsMap = JSON.parse(gtinsStr)
      const componentRefs = this.querySelector('[name="component_ref"]')?.value
      const sortedRefs = componentRefs.split(',').sort().join(',')
      const encoder = new TextEncoder()
      const data = encoder.encode(sortedRefs)
      const hashKeyBuffer = await window.crypto.subtle.digest('SHA-1', data)
      const hashKeyArray = Array.from(new Uint8Array(hashKeyBuffer))
      const hashHex = hashKeyArray.map(b => b.toString(16).padStart(2, '0')).join('')
      // Backend is expected to return only lower case keys in the metafield umg_bundles.flexible_gtin_map
      const hashHexLowerCase = hashHex.toLowerCase()
      return gtinsMap[hashHexLowerCase] || null
    }

    handleErrorMessage (errorMessage = false) {
      const submitButton = this.querySelector('[type="submit"]')
      const submitButtonLabel = submitButton.querySelector('.buybutton_label')
      const submitButtonLoadingSpinner = submitButton.querySelector('.icon--activity-spinning')

      submitButton.classList.remove('loading')
      submitButton.removeAttribute('disabled')
      submitButtonLabel.classList.remove('opacity-0')
      submitButtonLoadingSpinner.classList.add('hidden')

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
      if (!this.errorMessageWrapper) return
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

      this.errorMessageWrapper.removeAttribute('hidden')

      if (errorMessage) {
        this.errorMessage.innerHTML = errorMessage
      } else {
        this.errorMessage.textContent = window.cartStrings.error
      }
    }
  })
}
